// This is for the golf course list, summary data only. The reducer for the course detail is golfCourse.js
import { FETCH_GOLF_COURSES, FETCH_GOLF_COURSES_SUCCESS, FETCH_GOLF_COURSES_FAIL } from 'actions/golfCourseActions.js';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING'
};

const INITIAL_STATE = {
    golfCourses: [],
    networkingStatus: NETWORKING_STATUSES.SUCCESS
};

const fetchGolfCoursesSuccess = (state, action) => {
    return {
        golfCourses: action.golfCourses,
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchGolfCoursesStart = (state, action) => {
    return {
        golfCourses: state.golfCourses,
        networkingStatus: NETWORKING_STATUSES.FETCHING
    };
};

const fetchGolfCoursesFail = (state, action) => {
    return {
        golfCourses: state.golfCourses,
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const handlers = {
    [FETCH_GOLF_COURSES_SUCCESS]: fetchGolfCoursesSuccess,
    [FETCH_GOLF_COURSES]: fetchGolfCoursesStart,
    [FETCH_GOLF_COURSES_FAIL]: fetchGolfCoursesFail
};

export default function golfCourses(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchGolfCourses(evictCache) {
    return {
        type: FETCH_GOLF_COURSES,
        meta: {
            cacheTime: evictCache ? null : 600000 // 10 minutes
        }
    };
}

// Getters
export const getGolfCourses = (state) => {
    const keys = Object.keys(state.golfCourses.golfCourses);
    const golfCourses = keys.map((key) => state.golfCourses.golfCourses[key]);
    return golfCourses;
};

export const getGolfCoursesNetworkStatus = (state) => {
    return state.golfCourses.networkingStatus;
};

export const getNextGolfCourse = (state, currentId) => {
    const currentIdNumber = parseInt(currentId, 10);
    return state.golfCourses.golfCourses.find((course, index, courses) => {
        return index > 0 && currentIdNumber === courses[index - 1].courseSnapshotId;
    });
};

export const getPreviousGolfCourse = (state, currentId) => {
    const currentIdNumber = parseInt(currentId, 10);
    return state.golfCourses.golfCourses.find((course, index, courses) => {
        return index < courses.length - 1 && currentIdNumber === courses[index + 1].courseSnapshotId;
    });
};
